import React from 'react';
import { useRef } from 'react';
import {
    Card,
    FormLayout,
    TextField,
    Checkbox,
    Select,
    Button,
    Stack,
} from '@shopify/polaris';
import ValueMappingComponent from '../ValueMappingComponent';

export function UpdateProductMetafieldFromTagMappingSettings(props) {

    const mappingIdsRef = useRef([]);
    const nextMappingIdRef = useRef(0);

    // Assign stable IDs to any new mappings (covers initial load from backend + adds)
    while (mappingIdsRef.current.length < props.settings.valueMappings.length) {
        mappingIdsRef.current.push(nextMappingIdRef.current++);
    }

    const handleMetafieldTypeChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldType = value;
        props.onSettingsChange(newSettings);
    }

    const handleMetafieldNamespaceAndKeyChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldNamespaceAndKey = value;
        props.onSettingsChange(newSettings);
    }

    const onRemoveMetafieldValueWhenTagIsMissingChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.removeMetafieldValueWhenTagIsMissing = value;
        props.onSettingsChange(newSettings);
    }

    const handleMappingValueChange = (value, index) => {
        var entries = props.settings.valueMappings;
        entries[index].value = value;

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.valueMappings = entries;
        props.onSettingsChange(newSettings);
    }

    const handleMappingKeyChange = (value, index) => {
        var entries = props.settings.valueMappings;
        entries[index].key = value;

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.valueMappings = entries;
        props.onSettingsChange(newSettings);
    }

    const handleMappingDelete = (index) => {
        mappingIdsRef.current.splice(index, 1);

        let newArray = [
            ...props.settings.valueMappings.slice(0, index),
            ...props.settings.valueMappings.slice(index + 1)
        ];

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.valueMappings = newArray;
        props.onSettingsChange(newSettings);
    }

    const handleAddNewMapping = () => {
        const newArray = [
            ...props.settings.valueMappings,
            {
                key: "",
                value: ""
            }
        ];

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.valueMappings = newArray;
        props.onSettingsChange(newSettings);
    }

    const renderMappings = () => {
        var mappings = props.settings.valueMappings.map((item, index) => {
            var id = mappingIdsRef.current[index];
            return <ValueMappingComponent
                key={"mappingItem" + id}
                id={id}
                index={index}
                mappingKey={item.key}
                mappingValue={item.value}
                onDelete={handleMappingDelete}
                onValueChange={handleMappingValueChange}
                onKeyChange={handleMappingKeyChange}
            />
        });

        return <div>
            {mappings}
        </div>
    }

    return (
        <React.Fragment>
            <Card.Section title="Value Mapping">
                <Stack alignment='center'>
                    <Stack.Item>
                        <p>Map each tag to a metafield value.</p>
                    </Stack.Item>
                </Stack>
                <div><br />
                    {renderMappings()}
                    <br />
                    <Button plain onClick={handleAddNewMapping}>Add New Mapping</Button>
                </div>
            </Card.Section>
            <Card.Section>
                <FormLayout>
                    <TextField
                        label="Metafield Namespace and key"
                        placeholder="Namespace and key. For example mystore.custom_size"
                        helpText={
                            <span>
                                The namespace and key as they appear in your admin.
                            </span>
                        }
                        value={props.settings.metafieldNamespaceAndKey}
                        error={props.settingsErrors["metafieldNamespaceAndKey"]}
                        onChange={handleMetafieldNamespaceAndKeyChange}
                        autoComplete="off"
                    />
                    <Select
                        label="Metafield Type"
                        options={[
                            {
                                'label': 'Single line text',
                                'value': 'single_line_text_field'
                            },
                            {
                                'label': 'Multi line text',
                                'value': 'multi_line_text_field'
                            },
                            {
                                'label': 'List (single line text)',
                                'value': 'list.single_line_text_field'
                            }
                        ]}
                        onChange={handleMetafieldTypeChange}
                        value={props.settings.metafieldType}
                        helpText={
                            <span>
                                The type of the metafield that will be populated.
                            </span>
                        }
                    />
                    <Checkbox
                        label="Remove metafield value when tag is missing"
                        checked={props.settings.removeMetafieldValueWhenTagIsMissing}
                        onChange={onRemoveMetafieldValueWhenTagIsMissingChange}
                        helpText={
                            <span>
                                Metafield will not be set or will be removed when no matching tags are found on the product.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}
